import React from 'react';
import { Spinner } from 'react-bootstrap';

const PageLoader = ({ show , text = "Please Wait..." }) => {
  return (
    <div className={`loader-overlay ${show ? 'show' : ''}`}>
      <Spinner style={{height:40, width:40}} animation="border" variant="danger" />
      <p style={{fontSize:12}} className='d-block mt-3'>{text}</p>
    </div>
  );
};

export default PageLoader;
